import axios from 'axios';
import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { BASE_API_URL } from '@/constants';

import { IExamCenter } from '@/shared/model/exam-center.model';

const entityName = 'exam-centers';

export default class ExamCenterService {
  /**
   * Retrieve an examCenter by its ID
   * @param id  selected examCenter ID
   */
  public find(id: number): Promise<IExamCenter> {
    return new Promise<IExamCenter>((resolve, reject) => {
      axios
        .get(`${BASE_API_URL}${entityName}/${id}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Retrieve all examCenters
   * @param paginationQuery
   */
  public retrieve(paginationQuery?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(BASE_API_URL + entityName + `?${buildPaginationQueryOpts(paginationQuery)}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Delete an examCenter
   * @param id  examCenter to remove ID
   */
  public delete(id: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${BASE_API_URL}${entityName}/${id}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Create an examCenter
   * @param entity  examCenter to create
   */
  public create(entity: IExamCenter): Promise<IExamCenter> {
    return new Promise<IExamCenter>((resolve, reject) => {
      axios
        .post(`${BASE_API_URL}${entityName}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  /**
   * Update an examCenter
   * @param entity  examCenter to update
   */
  public update(entity: IExamCenter): Promise<IExamCenter> {
    return new Promise<IExamCenter>((resolve, reject) => {
      axios
        .put(`${BASE_API_URL}${entityName}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
